__turbopack_context__.v({
  "className": "literata_55e4b37e-module__6KRwDG__className",
});
